import { Panel, PanelType } from 'office-ui-fabric-react';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { addDays } from 'office-ui-fabric-react/lib/utilities/dateMath/DateMath';
import React, { Component } from 'react';
import Scriba from 'react-scriba';
import { DataTrancheTravaux } from '../../data/DataTrancheTravaux.jsx';
import { MaxLengths } from '../../data/MaxLenghts.jsx';
import { Immocom } from '../../specifique/immocom';
import { ComboBoxAgence } from '../ComboBox/ComboBoxAgence';
import { ComboBoxProgramme } from '../ComboBox/ComboBoxProgramme';
import { ComboBoxRegion } from '../ComboBox/ComboBoxRegion';
import { EUIDatePicker } from '../EUI/EUIDatePicker';
import { EUITextField } from '../EUI/EUITextField.jsx';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

/*
********************************************************************************************
PROPS :
    ATTRIBUTS :
        int     idProgramme                 ID du programme de la tranche travaux à modifier
        int     idTrancheTravaux            ID de la tranche travaux à modifier
        int     idRegion
        int     idAgence
        bool    isOpen                      détermine si panel ouvert ou non
    METHODES :
        void    onAnnulation                méthode appelée à la fermeture
        void    onEnregistrement            méthode appelée à l'enregistrement
********************************************************************************************
*/

export class FicheTrancheTravaux extends Component {
    constructor(props) {
        super(props);

        this.objetState = {
            trancheTravaux: {},

            messageEnCoursTraitement: '',
            hideMessageBarError: true,
            errorMessage: '',
            hideMessageBarWarning: true,
            warningMessage: '',

            onActiveBoutonEnregistrer: false
        };

        this.state = this.objetState;
    };

    _chargementDonnees = () => {
        if (this.props.idTrancheTravaux != 0 && this.props.idProgramme != 0 && this.props.idRegion != 0 && this.props.idAgence != 0) {
            this.setState({ messageEnCoursTraitement: "Chargement de la tranche travaux en cours..." });

            DataTrancheTravaux._chargementTrancheTravaux(
                this.props.idTrancheTravaux,
                this.props.idProgramme,
                this.props.idRegion,
                this.props.idAgence).then(responseFetch => {
                    const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                    if (retourVerif === null) {
                        const retourData = responseFetch.reponseAPIobjet;
                        const stateTemp = {
                            trancheTravaux: retourData[0],
                            periodeOuverture: retourData[1],
                            isDisabledDateSignatureOSTravaux: retourData[2]
                        };
                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, stateTemp, this._onVerificationFormulaire);
                    }
                    else
                        Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                });
        }
    };

    _onVerificationFormulaire = () => {
        Immocom.fiche()._validationFormulaire(this, 'TrancheTravaux', this.state.trancheTravaux, (this.props.idTrancheTravaux != "" ? 'Modification' : 'Création'));
    }

    _onAnnulation = () => {
        this._onInit();
        this.props.onAnnulation();
    };

    _onChangeInput = (champs) => (event, newValue) => {
        const trancheTravaux = { ...this.state.trancheTravaux };
        trancheTravaux[champs] = newValue;

        this.setState(
            { trancheTravaux: trancheTravaux },
            this._onVerificationFormulaire
        );
    };

    _onChangeCombobox = (champs) => (event, option, index, value) => {
        this.setState(
            { [champs]: option.key },
            this._setErrorMessage(champs)
        );
    };

    _onMiseAJourChamp = (nomPropriete, valeur) => {
        const trancheTravaux = { ...this.state.trancheTravaux };

        if (nomPropriete == "idRegion") {
            trancheTravaux.idRegion = valeur;
            trancheTravaux.idAgence = null;
            trancheTravaux.idProgramme = null;
        }
        else if (nomPropriete == "idAgence") {
            trancheTravaux.idAgence = valeur;
            trancheTravaux.idProgramme = null;
        }
        else if (nomPropriete == "idProgramme") {
            trancheTravaux.idProgramme = valeur;
        }

        this.setState({ trancheTravaux: trancheTravaux }, this._onVerificationFormulaire);
    };

    _onEnregistrement = () => {

        this.setState({ messageEnCoursTraitement: "Tranche travaux en cours d'enregistrement..." });

        //AF - Ajout d'une propriété trancheTravaux pour etre a iso périmetre avec la structure envoyée depuis les api 
        const objetTrancheTravaux = {
            trancheTravaux: this.state.trancheTravaux
            //{
            //    idTrancheTravaux: this.props.idTrancheTravaux,
            //    idProgramme: this.state.idProgramme,
            //    trancheTravaux: this.state.trancheTravaux,
            //    idRegion: this.state.idRegion,
            //    idAgence: this.state.idAgence
            //}
        }

        DataTrancheTravaux._onEnregistrementTrancheTravaux(objetTrancheTravaux).then(responseFetch => {
            let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, { ...this.state });
                this._onInit();
                this.props.onEnregistrement();
            }
            else {
                Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
            }
        });

    };

    _onInit = () => {
        this.setState(this.objetState);
    };

    _onOpen = () => {
        //if (this.props.idTrancheTravaux && this.props.idProgramme)

        this._chargementDonnees(); // Dans le cas d'une modification
        //this._chargementProgrammes();
    };

    _onRenderFooterContent = () => {
        return <Stack horizontal tokens={{ childrenGap: 10 }}>
            <PrimaryButton name="btnTTEnregistrer" onClick={this._onEnregistrement} disabled={!this.state.onActiveBoutonEnregistrer}>Enregistrer</PrimaryButton>
            <DefaultButton onClick={this._onAnnulation}>Annuler</DefaultButton>
        </Stack>
    };

    // MG - griser une date prévisionnelle si il existe une date réelle.
    _estRempli = (nomPropriete) => !!this.state.trancheTravaux[nomPropriete];

    _onSelectDate = (champs) => (event) => {
        const trancheTravaux = { ...this.state.trancheTravaux };
        const newDate = Scriba.date().getChaineISOFromDate(event, true);
        trancheTravaux[champs] = newDate;

        this.setState(
            { trancheTravaux: trancheTravaux },
            this._onVerificationFormulaire
        );
    };

    _renderPlanning = () => {
        const { trancheTravaux, periodeOuverture, isDisabledDateSignatureOSTravaux } = this.state;
        const aujourdhui = new Date(Date.now());
        const demain = addDays(aujourdhui, 1);
        const existePeriodeOuverte = !!periodeOuverture;
        const dateDebutPeriode = existePeriodeOuverte ? new Date(periodeOuverture.annee, new Date(periodeOuverture.dateDebut).getMonth(), 1) : null;

        return <div className="ms-Grid mt-2" dir="ltr">
            <div className="ms-Grid-row">
                <div className="ms-Grid-row lignePlanning">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xxxl6" />
                    <div className="ms-Grid-col ms-sm6 ms-lg4 ms-xxxl3">Date prévue</div>
                    <div className="ms-Grid-col ms-sm6 ms-lg4 ms-xxxl3">Date réelle</div>
                </div>
                <div className="ms-Grid-row lignePlanning">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xxxl6">Dépôt PC</div>
                    <div className="ms-Grid-col ms-sm6 ms-lg4 ms-xxxl3" name="divDateDepotPCPrevue">
                        <EUIDatePicker
                            disabled={this._estRempli("dateDepotPC")}
                            minDate={demain}
                            onSelectDate={this._onSelectDate('dateDepotPCPrevue')}
                            placeholder="Date prévue"
                            value={trancheTravaux.dateDepotPCPrevue}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm6 ms-lg4 ms-xxxl3" name="divDateDepotPC">
                        <EUIDatePicker
                            maxDate={aujourdhui}
                            onSelectDate={this._onSelectDate('dateDepotPC')}
                            placeholder="Date réelle"
                            value={trancheTravaux.dateDepotPC}
                        />
                    </div>
                </div>
                <div className="ms-Grid-row lignePlanning">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xxxl6">Obtention PC</div>
                    <div className="ms-Grid-col ms-sm6 ms-lg4 ms-xxxl3" name="divDateObtentionPCPrevue">
                        <EUIDatePicker
                            disabled={this._estRempli("dateObtentionPC")}
                            minDate={demain}
                            onSelectDate={this._onSelectDate('dateObtentionPCPrevue')}
                            placeholder="Date prévue"
                            value={trancheTravaux.dateObtentionPCPrevue}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm6 ms-lg4 ms-xxxl3" name="divDateObtentionPC">
                        <EUIDatePicker
                            maxDate={aujourdhui}
                            onSelectDate={this._onSelectDate('dateObtentionPC')}
                            placeholder="Date réelle"
                            value={trancheTravaux.dateObtentionPC}
                        />
                    </div>
                </div>
                <div className="ms-Grid-row lignePlanning">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xxxl6">Purge PC</div>
                    <div className="ms-Grid-col ms-sm6 ms-lg4 ms-xxxl3" name="divDatePurgePCPrevue">
                        <EUIDatePicker
                            disabled={this._estRempli("datePurgePC")}
                            minDate={demain}
                            onSelectDate={this._onSelectDate('datePurgePCPrevue')}
                            placeholder="Date prévue"
                            value={trancheTravaux.datePurgePCPrevue}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm6 ms-lg4 ms-xxxl3" name="divDatePurgePC">
                        <EUIDatePicker
                            maxDate={aujourdhui}
                            onSelectDate={this._onSelectDate('datePurgePC')}
                            placeholder="Date réelle"
                            value={trancheTravaux.datePurgePC}
                        />
                    </div>
                </div>
                <hr />
                <div className="ms-Grid-row lignePlanning">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xxxl6">Accord comité lancement travaux</div>
                    <div className="ms-Grid-col ms-sm6 ms-lg4 ms-xxxl3" />
                    <div className="ms-Grid-col ms-sm6 ms-lg4 ms-xxxl3" name="divDateAccordComiteLancementTravaux">
                        <EUIDatePicker
                            maxDate={aujourdhui}
                            onSelectDate={this._onSelectDate('dateAccordComiteLancementTravaux')}
                            placeholder="Date réelle"
                            value={trancheTravaux.dateAccordComiteLancementTravaux}
                        />
                    </div>
                </div>
                <div className="ms-Grid-row lignePlanning">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xxxl6">Signature OS travaux</div>
                    <div className="ms-Grid-col ms-sm6 ms-lg4 ms-xxxl3" name="divDateSignatureOSTravauxPrevue">
                        <EUIDatePicker
                            disabled={this._estRempli("dateSignatureOSTravaux")}
                            minDate={demain}
                            onSelectDate={this._onSelectDate('dateSignatureOSTravauxPrevue')}
                            placeholder="Date prévue"
                            value={trancheTravaux.dateSignatureOSTravauxPrevue}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm6 ms-lg4 ms-xxxl3" name="divDateSignatureOSTravaux">
                        <EUIDatePicker
                            disabled={isDisabledDateSignatureOSTravaux}
                            minDate={existePeriodeOuverte ? dateDebutPeriode : null}
                            maxDate={aujourdhui}
                            onSelectDate={this._onSelectDate('dateSignatureOSTravaux')}
                            placeholder="Date réelle"
                            title="Cette date n'est pas modifiable si elle est antérieure à une date de clôture CG, ou ultérieure à la date d'aujourd'hui"
                            value={trancheTravaux.dateSignatureOSTravaux}
                        />
                    </div>
                </div>
                <div className="ms-Grid-row lignePlanning">
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xxxl6">Achèvement</div>
                    <div className="ms-Grid-col ms-sm6 ms-lg4 ms-xxxl3" name="divDateAchevementPrevue">
                        <EUIDatePicker
                            disabled={this._estRempli("dateAchevement")}
                            minDate={demain}
                            onSelectDate={this._onSelectDate('dateAchevementPrevue')}
                            placeholder="Date prévue"
                            value={trancheTravaux.dateAchevementPrevue}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm6 ms-lg4 ms-xxxl3" name="divDateAchevement">
                        <EUIDatePicker
                            maxDate={aujourdhui}
                            onSelectDate={this._onSelectDate('dateAchevement')}
                            placeholder="Date réelle"
                            value={trancheTravaux.dateAchevement}
                        />
                    </div>
                </div>
            </div>
        </div>;
    };

    render = () => {
        const modeCreation = (this.state.trancheTravaux.idTrancheTravaux == undefined);
        const disabledRegion = !modeCreation;
        const disabledAgence = disabledRegion || (!disabledRegion && !(this.state.trancheTravaux.idRegion > 0));
        const disabledProgramme = disabledAgence || (!disabledAgence && !(this.state.trancheTravaux.idAgence > 0));
        const aujourdhui = new Date(Date.now());

        return <Panel
            closeButtonAriaLabel="Fermer"
            headerText={this.props.idTrancheTravaux ? "Modifier une tranche travaux" : "Créer une tranche travaux"}
            isOpen={this.props.isOpen}
            onDismiss={this._onAnnulation}
            onOpen={this._onOpen}
            onRenderFooterContent={this._onRenderFooterContent}
            type={PanelType.medium}
        >

            {this.state.messageEnCoursTraitement.length > 0 ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <MessageBars
                errorMessage={this.state.errorMessage}
                warningMessage={this.state.warningMessage}
                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
            />
            <ComboBoxRegion
                disabled={disabledRegion}
                name="divRegion"
                onChange={(event, option, index, value, item) => this._onMiseAJourChamp("idRegion", option.key)}
                required
                selectedKey={this.state.trancheTravaux.idRegion}
            />
            <ComboBoxAgence
                disabled={disabledAgence}
                idRegion={this.state.trancheTravaux.idRegion}
                name="divAgence"
                onChange={(event, option, index, value, item) => this._onMiseAJourChamp("idAgence", option.key)}
                required
                selectedKey={this.state.trancheTravaux.idAgence}
            />
            <ComboBoxProgramme
                disabled={disabledProgramme}
                idAgence={this.state.trancheTravaux.idAgence}
                idRegion={this.state.trancheTravaux.idRegion}
                name="divProgramme"
                onChange={(event, option, index, value, item) => this._onMiseAJourChamp("idProgramme", option.key)}
                required
                selectedKey={this.state.trancheTravaux.idProgramme}
            />
            <EUITextField
                name="divTrancheTravaux"
                label="Tranche travaux"
                maxLength={MaxLengths.trancheTravaux.trancheTravaux}
                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                onDelayedChange={this._onChangeInput("trancheTravaux")}
                required
                value={this.state.trancheTravaux.trancheTravaux}
            />
            <EUITextField
                name="divPermis"
                label="N° permis de construire"
                maxLength={MaxLengths.trancheTravaux.numPC}
                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "trancheTravaux", "numPC", newValue, this._onVerificationFormulaire)}
                value={this.state.trancheTravaux.numPC}
            />
            <EUITextField
                name="divNomMairie"
                label="Nom mairie"
                maxLength={MaxLengths.trancheTravaux.nomMairie}
                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "trancheTravaux", "nomMairie", newValue, this._onVerificationFormulaire)}
                value={this.state.trancheTravaux.nomMairie}
            />

            {this._renderPlanning()}

            <EUIDatePicker
                name="divDateAbandon"
                label="Date abandon"
                maxDate={aujourdhui}
                onSelectDate={this._onSelectDate('dateAbandon')}
                placeholder="Date abandon"
                value={this.state.trancheTravaux.dateAbandon}
            />
        </Panel>

    };

}